import React from 'react';

// "Powered by Stripe" trust badge for payment surfaces.
// The Stripe wordmark follows brand guidelines: blurple on light, white on dark.
const PoweredByStripe = ({ className = '' }) => (
  <div className={`flex items-center justify-center gap-1.5 text-gray-400 dark:text-gray-500 ${className}`}>
    <span className="text-xs">Powered by</span>
    <svg
      role="img"
      aria-label="Stripe"
      viewBox="0 0 60 25"
      height="14"
      width="34"
      className="text-[#635BFF] dark:text-white"
      fill="currentColor"
    >
      <path d="M59.64 14.28h-8.06c.19 1.93 1.6 2.55 3.2 2.55 1.64 0 2.96-.37 4.05-.95v3.32a8.33 8.33 0 0 1-4.56 1.1c-4.01 0-6.83-2.5-6.83-7.48 0-4.19 2.39-7.52 6.3-7.52 3.92 0 5.96 3.28 5.96 7.5 0 .4-.04 1.26-.06 1.48zm-5.92-5.62c-1.03 0-2.17.73-2.17 2.58h4.25c0-1.85-1.07-2.58-2.08-2.58zM40.95 20.3c-1.44 0-2.32-.6-2.9-1.04l-.02 4.63-4.12.88V5.57h3.76l.08 1.02a4.7 4.7 0 0 1 3.23-1.29c2.9 0 5.62 2.6 5.62 7.4 0 5.23-2.7 7.6-5.65 7.6zM40 8.95c-.95 0-1.54.34-1.97.81l.02 6.12c.4.44.98.78 1.95.78 1.52 0 2.54-1.65 2.54-3.87 0-2.15-1.04-3.84-2.54-3.84zM28.24 5.57h4.13v14.44h-4.13V5.57zm0-4.7L32.37 0v3.36l-4.13.88V.88zm-4.32 9.35v9.79H19.8V5.57h3.7l.12 1.22c1-1.77 3.07-1.41 3.62-1.22v3.79c-.52-.17-2.29-.43-3.32.86zm-8.55 4.72c0 2.43 2.6 1.68 3.12 1.46v3.36c-.55.3-1.54.54-2.89.54a4.15 4.15 0 0 1-4.27-4.24l.02-13.17 4.02-.86v3.54h3.12v3.53h-3.12v5.85zM5.07 9.51c-.86 0-1.39.24-1.39.86 0 .68.88.98 1.97 1.35 1.79.6 4.07 1.55 4.08 4.42 0 2.77-2.2 4.36-5.42 4.36-1.33 0-2.78-.26-4.21-.87v-3.93c1.3.71 2.95 1.24 4.21 1.24.91 0 1.56-.24 1.56-.97 0-.75-.95-1.1-2.1-1.49C2.01 13.94 0 13 0 10.36 0 7.6 2.09 6 5.23 6c1.28 0 2.55.2 3.83.71v3.88a8.5 8.5 0 0 0-3.99-1.08z" />
    </svg>
  </div>
);

export default PoweredByStripe;
